import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Loader from 'kepler/lib/components/Loader';
import _find from 'lodash/find';
import { HeadingText } from '@paypalcorp/pp-react';
import AccordionTopicGroup from '../components/AccordionTopicGroup';
import ErrorPanel from '../components/ErrorPanel';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import Breadcrumb from './Breadcrumb';
import { ARTICLE_LIST, BREADCRUMB_ITEM, TOPIC } from '../constants/PropTypesShapes';
import { setContextApiCallForExp } from '../../contactUs/actions/action-article';
import { isNewExpLayoutEnabled } from '../../../jsV2/helpers/twHelper';

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const maxbcLength = 3;

const ArticleList = function (props) {
  const {
    articleList,
    breadcrumb,
    SelectedL1TopicDetails,
    SelectedL2TopicDetails,
    SelectedL3TopicDetails,
    isL3TopicClicked,
  } = props;

  const getActiveTopic = () => {
    let selectedArticle;
    if (breadcrumb && breadcrumb.length && (breadcrumb.length === maxbcLength || Page.isMobileLayout())) {
      selectedArticle = _find(
        articleList.articleList,
        (article) => breadcrumb[breadcrumb.length - 1].id === article.id,
      );
    }
    if (SelectedL3TopicDetails) {
      selectedArticle = SelectedL3TopicDetails;
    }
    if (!isL3TopicClicked && SelectedL2TopicDetails) {
      selectedArticle = SelectedL2TopicDetails;
    }

    return selectedArticle;
  };
  const setOCPContext = (topic) => {
    const newExpLayoutEnaled = isNewExpLayoutEnabled();
    if (newExpLayoutEnaled) {
      props.setContextApiCallForExp([{ customer_intent: topic.ocpIntent }], '', true);
    }
  };
  const renderArticleList = () => {
    if (!articleList.articleList) {
      return null;
    }
    const options = { name: 'home' };
    Page.setCanonicalTag(options);
    const topics = articleList;
    return (
      <AccordionTopicGroup
        topics={topics}
        activeTopic={getActiveTopic()}
        isL3TopicClicked={isL3TopicClicked}
        SelectedL1TopicDetails={SelectedL1TopicDetails}
        callSetContextForExp={setOCPContext}
      />
    );
  };

  const renderContents = () => {
    if (articleList.isLoading) {
      return <Loader size="lg" show type="fixed" />;
    }
    if (articleList.error) {
      return <ErrorPanel pageName="topicErrorPage" />;
    }
    return renderArticleList();
  };

  const getBreadcrumbItems = () => {
    // display breadcrumbs only for L2 and L3 topics from props,
    // if article is clicked breadcrumbs are rendered in article page
    if (Array.isArray(breadcrumb) && breadcrumb.length && isL3TopicClicked) {
      return breadcrumb.slice(0, 2);
    }
    if (!articleList.error) {
      return [
        {
          path: '/home',
          title: label,
        },
        {
          path: `/topic/${articleList.articleId}`,
          title: articleList.articleTitle,
        },
      ];
    }
    return [];
  };
  Page.setDocumentTitle(articleList.articleTitle);

  // Currently testing SEO changes for US / UK markets thus we are adding a title meta tag.
  const shouldDisplayMetaFaq = Page.getIsMarketEnabledForSeoTitle();
  const metaTitleText = shouldDisplayMetaFaq ? `${articleList.articleTitle} - FAQ` : '';

  return (
    <div className="topic-articlelist-container">
      <Breadcrumb items={getBreadcrumbItems()} />
      <HeadingText size="sm" theme="v2">
        {articleList.articleTitle}
      </HeadingText>
      {shouldDisplayMetaFaq && <meta name="title" content={metaTitleText} />}
      <div className="contents">{renderContents()}</div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    articleList: state.articleList,
    breadcrumb: state.breadcrumb.items,
    SelectedL1TopicDetails: state.L3TopicList.SelectedL1TopicDetails,
    SelectedL2TopicDetails: state.L3TopicList.SelectedL2TopicDetails,
    SelectedL3TopicDetails: state.L3TopicList.SelectedL3TopicDetails,
    isL3TopicClicked: state.L3TopicList.isL3TopicClicked,
  };
}

ArticleList.propTypes = {
  articleList: PropTypes.arrayOf(PropTypes.shape(ARTICLE_LIST)).isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape(BREADCRUMB_ITEM)),
  SelectedL1TopicDetails: PropTypes.shape(TOPIC).isRequired,
  SelectedL2TopicDetails: PropTypes.shape(TOPIC).isRequired,
  SelectedL3TopicDetails: PropTypes.shape(TOPIC).isRequired,
  isL3TopicClicked: PropTypes.bool.isRequired,
  setContextApiCallForExp: PropTypes.func,
};

ArticleList.defaultProps = {
  breadcrumb: [],
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setContextApiCallForExp,
    },
    dispatch,
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(ArticleList);
